import { formatCount } from '../number/count';

/**
 * Basis points as a whole percent, FLOORED and grouped: "49%", "1,250%".
 * For a figure read against a line, so one just under the line never
 * prints as the line itself (4,999 bps reads "49%", never "50%").
 */
export function formatFlooredPercent(bps: number): string {
  return `${formatCount(Math.floor(bps / 100))}%`;
}
